export default __webpack_public_path__ + "static/media/icon_button.df259d1a.svg";